// extracted by mini-css-extract-plugin
export default {"Divider":"Bm8K7"};